import { ComponentTypes, USER_FEEDBACK } from './constants';

/**
 * Helper function to check if a component should be hidden
 * @param {object} currentUiInstruction - The button instruction to check
 * @param {Array} uiInstructionsCurrentGroup - Instructions within the same group
 * @param {number} currentIndex - Current instruction group index
 * @param {number} latestTextUserResponseIndex - Latest text UserResponse index
 * @param {number} latestButtonGroupIndex - Latest button group index
 * @param {Array} uiInstructionsNextGroup - UI instructions for the next instruction group
 * @returns {boolean} Whether the component should be hidden
 */
function shouldHideComponent(
  currentUiInstruction,
  uiInstructionsCurrentGroup,
  currentIndex,
  latestTextUserResponseIndex,
  latestButtonGroupIndex,
  uiInstructionsNextGroup
) {
  if (
    ![ComponentTypes.BUTTON_PROMPT, ComponentTypes.FEEDBACK_FORM].includes(
      currentUiInstruction.componentType
    )
  ) {
    return false;
  }

  // Show feedback form always if customer gave feedback
  if (
    [ComponentTypes.FEEDBACK_FORM].includes(currentUiInstruction.componentType) &&
    currentUiInstruction?.props?.value !== USER_FEEDBACK.NEUTRAL
  ) {
    return false;
  }

  // Hide feedback form only if:
  // 1. There's a next instruction group and customer didn't give feedback
  if (
    [ComponentTypes.FEEDBACK_FORM].includes(currentUiInstruction.componentType) &&
    uiInstructionsNextGroup?.length &&
    currentUiInstruction?.props?.value === USER_FEEDBACK.NEUTRAL
  ) {
    return true;
  }

  // Hide buttons only if:
  // 1. There's a next instruction group but it's not an article-generation message
  // 2. There's a text-based UserResponse in the conversation, AND
  // 3. This instruction group comes before or at the same level as the latest text UserResponse
  if (
    [ComponentTypes.BUTTON_PROMPT].includes(currentUiInstruction.componentType) &&
    uiInstructionsNextGroup?.length &&
    // when customer clicks on article-selection we create a new message for article-generation
    !uiInstructionsNextGroup.some((uiInstruction) => uiInstruction.componentType === 'Article')
  ) {
    return true;
  }

  if (latestTextUserResponseIndex >= 0 && currentIndex <= latestTextUserResponseIndex) {
    return true;
  }

  // Hide buttons if this instruction group comes before the latest button group
  if (latestButtonGroupIndex >= 0 && currentIndex < latestButtonGroupIndex) {
    return true;
  }

  // Otherwise, check if ANY UserResponse exists within the same instruction group
  return uiInstructionsCurrentGroup.some(
    (uiInstruction) => uiInstruction.componentType === ComponentTypes.USER_RESPONSE
  );
}

export default shouldHideComponent;
